import React from 'react';
import PropTypes from 'prop-types';

import defaultCategories from '../constants/categories';
import ToggleButton from './ToggleButton';

class CategorySelect extends React.Component {
  // constructor(props) {
  //   super(props);
  // }
  toggleCategory = (category, value) => {
    const categories = this.props.categories.map(item => {
      if (item.name !== category) return item;
      return {
        ...item,
        active: value,
      };
    });
    this.props.onChange(categories);
  };
  render() {
    return (
      <div className="CategorySelect">
        {this.props.categories.map(category => (
          <div className="CategorySelect-item" key={category.name}>
            <div className="CategorySelect-name">{category.name}</div>
            <ToggleButton
              name={category.name}
              onToggle={value => this.toggleCategory(category.name, value)}
              defaultChecked={category.active}
            />
          </div>
        ))}
      </div>
    );
  }
}

CategorySelect.propTypes = {
  categories: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

CategorySelect.defaultProps = {
  categories: defaultCategories.map(category => ({
    ...category,
    active: true,
  })),
};

export default CategorySelect;



// WEBPACK FOOTER //
// ./src/js/components/CategorySelect.js